module.exports = __webpack_public_path__ + "img/check.3d6d6dab.png";